import {Locales} from '@netx/core-next/locales/utils/Locales';

export const ProjectReviewsLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.reviews'),
}));
